import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: '[contextMenu]',
  standalone: false
})
export class ContextMenuDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}

